/**
 * One name for how an order was paid, shared by every checkout in this app.
 *
 * The value rides along in the /api/checkout-stripe payload, so it is what the
 * team sees on the order, and the Fast Track upsell modal reads it to decide
 * whether there is a card on file to re-bill. Klarna and the typed card set
 * theirs directly. These two helpers cover the wallet buttons, where Stripe
 * reports the wallet under a different name in each API.
 */

/**
 * Express Checkout Element. Stripe's `expressPaymentType` is already spelled the
 * way we store it, so the only work is refusing a value we do not know.
 * @see node_modules/@stripe/stripe-js/dist/stripe-js/elements/express-checkout.d.ts
 */
const EXPRESS_TYPES = ['apple_pay', 'google_pay', 'link', 'amazon_pay', 'paypal'];

export function paymentMethodFromExpressType(expressPaymentType) {
    return EXPRESS_TYPES.includes(expressPaymentType) ? expressPaymentType : 'card';
}

/**
 * Payment Request Button. `walletName` is camelCase, and the `methodName` beside
 * it is deprecated: it carries a URL such as https://apple.com/apple-pay rather
 * than a bare wallet name, so a `methodName === 'apple-pay'` test never matches.
 * @see node_modules/@stripe/stripe-js/dist/stripe-js/payment-request.d.ts
 */
const WALLET_NAMES = {
    applePay: 'apple_pay',
    googlePay: 'google_pay',
    link: 'link',
    browserCard: 'card',
};

export function paymentMethodFromWalletName(walletName) {
    return WALLET_NAMES[walletName] || 'card';
}
